module.exports = __webpack_public_path__ + "static/media/Chansey_gaussian2.62e6320c.png";